import { useState, useRef, useEffect } from "react";
import LatestCard from "./LatestCard";
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';
import { CDSUiIcons } from '@cencora-design-system/assets/icons';
import './LatestChange.css'

export default function LatestChange(props) {
    // Restore carousel position from sessionStorage
    // const getInitialIndex = () => {
    //     const saved = sessionStorage.getItem('carouselIndex');
    //     return saved ? parseInt(saved, 10) : 0;
    // };

    const [currentIndex, setCurrentIndex] = useState(0);
    const visibleCards = 3; // Always show 3 cards
    const carouselRef = useRef(null);

    // Use API data
    const rawData = props.results?.items || [];
    console.log("Raw data for latest changes:", rawData);

    // Process data to extract latest update description
    const data = rawData.map(item => {
        // Get the latest update from latestUpdates array (sorted by changedAt)
        const latestUpdates = item.latestUpdates || [];
        const sortedUpdates = [...latestUpdates].sort((a, b) =>
            new Date(b.changedAt) - new Date(a.changedAt)
        );
        const latestUpdate = sortedUpdates[0];

        return {
            cardId: item.id,
            title: item.title,
            description: latestUpdate?.changeDescription || item.aiSummary || 'No description available',
            sourceUrl: item.sourceUrl,
            id: item.id,
            isLike: item.isLike || false,
            isDislike: item.isDislike || false,
            rawData: item
        };
    });

    // Save carousel position to sessionStorage whenever it changes
    useEffect(() => {
        // Only save if we have data loaded
        if (data.length > 0) {
            sessionStorage.setItem('carouselIndex', currentIndex.toString());
        }
    }, [currentIndex, data.length]);

    // Reset currentIndex if it's out of bounds when data changes
    useEffect(() => {
        // Only reset if data is loaded
        if (data.length > 0) {
            const maxIndex = Math.max(0, data.length - visibleCards);
            if (currentIndex > maxIndex) {
                setCurrentIndex(maxIndex);
            }
        }
    }, [data.length, currentIndex]);

    // useEffect(() => {
    //     const totalLoaded = props.results.items.length;
    //     if(currentIndex >= totalLoaded - visibleCards - 2 && props.results.page < props.results.totalPages) {
    //         props.fetchNextPage(props.results.page + 1);
    //     }
    // }, [currentIndex]);

    const next = () => {
        const maxIndex = data.length - visibleCards;
        if (currentIndex < maxIndex) {
            // Move by visibleCards, but don't exceed maxIndex
            setCurrentIndex(Math.min(currentIndex + visibleCards, maxIndex));
        }
        if (!props.loadingNextPage && props.results.page < props.results.totalPages) {
            props.fetchNextPage(props.results.page + 1);
        }
    };

    const prev = () => {
        if (currentIndex > 0) {
            // Move by visibleCards, but don't go below 0
            setCurrentIndex(Math.max(currentIndex - visibleCards, 0));
        }
    };

    return <div>
        <h3 className="latest-title">Latest updates
        </h3>
        {!props.latestLoading ? (<div className="latest-container">

            <div className="carousel-container">
                <button
                    className="carousel-nav-arrow carousel-nav-left"
                    onClick={prev}
                    disabled={currentIndex === 0}
                >
                    <SlIcon src={CDSUiIcons.IconArrowLeft1} />
                </button>
                <div className="carousel-wrapper" ref={carouselRef}>
                    <div className="latest-cards" style={{ transform: `translateX(-${currentIndex * 266}px)` }}>
                        {data.map((item, index) => (
                            <LatestCard key={index} {...item} dislikedCard={props.dislikedCard} handleCardDislike={props.handleCardDislike} onDislike={props.onDislike} isDisliked={props.isDisliked} onDislikeClick={props.onDislikeClick} userId={props.userId} />
                        ))}
                    </div>
                </div>
                <button
                    className="carousel-nav-arrow carousel-nav-right"
                    onClick={next}
                    disabled={currentIndex >= data.length - visibleCards}
                >
                    <SlIcon src={CDSUiIcons.IconArrowRight1} />
                </button>
            </div>
        </div>) : (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <div className="loading-text">Loading latest updates</div>
            </div>
        )}</div>
}
